import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "upload";

const UPLOAD_IMAGE_URL = `${prefix}/upload-image`;
const UPLOAD_IMAGE_FILE_URL = `${prefix}/upload-image-file`;

/**
 * Start
 * @func uploadImage
 * @desc upload image
 * @author izeberg
 * @param {string} imageBase64 - base64 string
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {string} image path
 */
export const uploadImage = async (imageBase64, signal) => {
    try {
        const { data, status } = await axios.post(
            UPLOAD_IMAGE_URL,
            { imageBase64 },
            {
                signal,
            },
        );
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "uploadImage");
        if (err) throw err;
        return undefined;
    }
};
/** End @func uploadImage */

/**
 * Start
 * @func uploadImageFile
 * @desc upload image
 * @author izeberg
 * @param {Object} formData - form data
 * @param {File} formData.image - image type file
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {string} image path
 */
export const uploadImageFile = async (formData, signal) => {
    try {
        const { data, status } = await axios.post(UPLOAD_IMAGE_FILE_URL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "uploadImageFile");
        if (err) throw err;
        return undefined;
    }
};
/** End @func uploadImageFile */
